import React from 'react'

function HeadlineHero() {
  return (
    
    <section className="bg-gray-50 text-black">
      <div className="max-w-7xl mx-auto px-6 py-28 text-center">
        
        <h1 className="text-4xl md:text-6xl font-bold leading-tight pb-6">
          Powering the Future Through{" "}
          <span className="text-yellow-400">Engineering Excellence</span>
        </h1>

        <p className="max-w-3xl mx-auto text-lg md:text-xl text-black pb-10">
          Global Electric Power Development Corporation delivers reliable
          Engineering, Procurement, and Construction (EPC) solutions for
          utility-scale solar power plants and electrical infrastructure across
          the Philippines.
        </p>
      </div>
    </section>
  )
}

export default HeadlineHero